import { lineSymbolExtensionInstall } from './line';

export default [lineSymbolExtensionInstall];
